/**
 * Removes all scripts from Vue instance element before it instantiates
 */

 const siteWrapper = document.querySelector('#root')
 const scripts = [...siteWrapper.querySelectorAll('script')]
 const styles = [...siteWrapper.querySelectorAll('style')]

scripts.forEach(script => script.remove())
styles.forEach(style => style.remove())

